<!-- Sidebar CSS Start Here  -->
<div class="sidenavwrap">
  <ul>
    <li class="menulist" *ngFor="let item of menuList">
      <a *ngIf="item.role_id == 1" href="javascript:void(0);" routerLinkActive="active" routerLink="/dashboard"><svg
          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_element-4" data-name="vuesax/bold/element-4" transform="translate(-684 -252)">
            <g id="element-4">
              <path id="Vector" d="M0,0H24V24H0Z" transform="translate(708 276) rotate(180)" fill="none" opacity="0" />
              <g id="Group_5117" data-name="Group 5117">
                <path id="Vector-2" data-name="Vector"
                  d="M8.5,8.9V2.1C8.5.6,7.86,0,6.27,0H2.23C.64,0,0,.6,0,2.1V8.9C0,10.4.64,11,2.23,11H6.27C7.86,11,8.5,10.4,8.5,8.9Z"
                  transform="translate(697 254)" fill="#b1b1b1" />
                <path id="Vector-3" data-name="Vector"
                  d="M8.5,2.1V8.9c0,1.5-.64,2.1-2.23,2.1H2.23C.64,11,0,10.4,0,8.9V2.1C0,.6.64,0,2.23,0H6.27C7.86,0,8.5.6,8.5,2.1Z"
                  transform="translate(686.5 263)" fill="#b1b1b1" />
                <path id="Vector-4" data-name="Vector"
                  d="M8.5,4.9V2.1C8.5.6,7.86,0,6.27,0H2.23C.64,0,0,.6,0,2.1V4.9C0,6.4.64,7,2.23,7H6.27C7.86,7,8.5,6.4,8.5,4.9Z"
                  transform="translate(697 267)" fill="#b1b1b1" />
                <path id="Vector-5" data-name="Vector"
                  d="M8.5,4.9V2.1C8.5.6,7.86,0,6.27,0H2.23C.64,0,0,.6,0,2.1V4.9C0,6.4.64,7,2.23,7H6.27C7.86,7,8.5,6.4,8.5,4.9Z"
                  transform="translate(686.5 254)" fill="#b1b1b1" />
              </g>
            </g>
          </g>
        </svg><span>{{item?.role_name}}</span></a>

      <a *ngIf="item.role_id == 2" href="javascript:void(0);" routerLinkActive="active" routerLink="/customers-list">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_profile-2user" data-name="vuesax/bold/profile-2user" transform="translate(-172 -252)">
            <g id="profile-2user">
              <path id="Vector" d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(176.25 254)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
                transform="translate(173.96 264.755)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector"
                d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
                transform="translate(186.11 256.057)" fill="#b1b1b1" />
              <path id="Vector-4" data-name="Vector"
                d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
                transform="translate(185.99 264.5)" fill="#b1b1b1" />
              <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(196 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg><span>{{item.role_name}}</span> </a>

      <a *ngIf="item.role_id == 22" href="javascript:void(0);" routerLinkActive="active"
        routerLink="/missing-user-data">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_profile-2user" data-name="vuesax/bold/profile-2user" transform="translate(-172 -252)">
            <g id="profile-2user">
              <path id="Vector" d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(176.25 254)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
                transform="translate(173.96 264.755)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector"
                d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
                transform="translate(186.11 256.057)" fill="#b1b1b1" />
              <path id="Vector-4" data-name="Vector"
                d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
                transform="translate(185.99 264.5)" fill="#b1b1b1" />
              <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(196 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg><span>{{item.role_name}}</span> </a>
      <a *ngIf="item.role_id == 23" href="javascript:void(0);" routerLinkActive="active"
        routerLink="/least-valuable-members">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_profile-2user" data-name="vuesax/bold/profile-2user" transform="translate(-172 -252)">
            <g id="profile-2user">
              <path id="Vector" d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(176.25 254)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
                transform="translate(173.96 264.755)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector"
                d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
                transform="translate(186.11 256.057)" fill="#b1b1b1" />
              <path id="Vector-4" data-name="Vector"
                d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
                transform="translate(185.99 264.5)" fill="#b1b1b1" />
              <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(196 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg><span>{{item.role_name}}</span> </a>


      <a *ngIf="item.role_id == 20" href="javascript:void(0);" routerLinkActive="active" routerLink="/user-metrics">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <!-- Reusing profile icon for now -->
          <g id="vuesax_bold_profile-2user-metrics" data-name="vuesax/bold/profile-2user"
            transform="translate(-172 -252)">
            <g id="profile-2user-metrics">
              <path d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(176.25 254)" fill="#b1b1b1" />
              <path
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
                transform="translate(173.96 264.755)" fill="#b1b1b1" />
              <path
                d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
                transform="translate(186.11 256.057)" fill="#b1b1b1" />
              <path
                d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
                transform="translate(185.99 264.5)" fill="#b1b1b1" />
              <path d="M0,0H24V24H0Z" transform="translate(196 276) rotate(180)" fill="none" opacity="0" />
            </g>
          </g>
        </svg><span>{{item.role_name}}</span> </a>

      <div class="sub-menu-wrap submenu4" *ngIf="item.role_id == 21">
        <a class="collapsed addClass" href="#submenu4sub4" data-toggle="collapse" data-target="#submenu4sub4">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="vuesax_bold_chart-21" data-name="vuesax/bold/chart-21" transform="translate(-172 -252)">
              <path d="M0,0H24V24H0Z" transform="translate(172 252)" fill="none" opacity="0" />
              <path
                d="M14.65,0H3.35A3.2,3.2,0,0,0,0,3V21a3.2,3.2,0,0,0,3.35,3H14.65A3.2,3.2,0,0,0,18,21V3A3.2,3.2,0,0,0,14.65,0ZM6,17.5a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Zm0-4.5a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Zm0-4.5a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
                transform="translate(175 252)" fill="#b1b1b1" />
            </g>
          </svg>
          <span>{{item.role_name}}</span> <i class="fas fa-angle-up"></i>
        </a>
        <div class="collapse firstmenu" id="submenu4sub4" aria-expanded="false">
          <ul class="flex-column nav" id="accordion">
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);"
                routerLink="/subscription-analytics" routerLinkActive="active">
                <span> Subscription Analytics </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/like-analytics"
                routerLinkActive="active">
                <span> Like Analytics </span>
              </a>
            </li>
          </ul>
        </div>
      </div>


      <!-- <div class="sub-menu-wrap submenu1" *ngIf="item.role_id == 3">
          <a href="#submenu1sub1" data-toggle="collapse" data-target="#submenu1sub1"  (click)="isShow=!isShow" [ngClass]="isShow?'firstaddClass':'firstaddClass collapsed'" [attr.aria-expanded]="isShow ? 'true' : 'false'" >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g id="vuesax_bold_setting-4" data-name="vuesax/bold/setting-4" transform="translate(-428 -190)">
                <g id="setting-4">
                  <path id="Vector"
                    d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,0,1,.7.7A.7.7,0,0,1,6.28,1.4Z"
                    transform="translate(443.02 196.18)" fill="#b1b1b1" />
                  <path id="Vector-2" data-name="Vector"
                    d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,0,1.4Z"
                    transform="translate(430 196.18)" fill="#b1b1b1" />
                  <path id="Vector-3" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                    transform="translate(434.19 192.93)" fill="#b1b1b1" />
                  <path id="Vector-4" data-name="Vector"
                    d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,.7.7A.7.7,0,0,1,4.42,1.4Z"
                    transform="translate(444.88 206.41)" fill="#b1b1b1" />
                  <path id="Vector-5" data-name="Vector"
                    d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,1,1,0,1.4Z"
                    transform="translate(430 206.41)" fill="#b1b1b1" />
                  <path id="Vector-6" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                    transform="translate(437.91 203.17)" fill="#b1b1b1" />
                  <path id="Vector-7" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(452 214) rotate(180)"
                    fill="none" opacity="0" />
                </g>
              </g>
            </svg> <span>{{item.role_name}}</span> <i class="fas fa-angle-up"></i>
          </a>
          <div  id="submenu1sub1" aria-expanded="false"  [ngClass]="isShow?'firstmenu show':' hide'" [attr.aria-expanded]="isShow ? 'true' : 'false'"  [ngStyle]="{ 'display': isShow ? 'block' : 'none' }">
            <ul class="flex-column nav" id="accordion"   [ngStyle]="{ 'display': isShow ? 'block' : 'none' }">
              <li class="nav-item">
                <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/hobbie" routerLinkActive="active">
                <span> Hobbies </span>
              </a>
              
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/fitness">
                <span> Fitness </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"  routerLink="/alcohol-consumption">
                <span> Alcohol Consumption </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/smoker">
                <span> Smoker </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/wake-up-list">
                <span> I usually wake up at </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"   routerLink="/interest">
                <span> Interest </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/personality">
                <span> Personality </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/values-list">
                <span> Values </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/life-goals-list">
                <span> Life Goals </span>
              </a>
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/maxion-goals-list">              
                <span>Maxion Goals </span>
              </a>
  
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active" routerLink="/meet-vibes-list">
                <span>Meet Vibes</span>
              </a>
              </li>
            </ul>
          </div>
        </div> -->

      <div class="sub-menu-wrap submenu1" *ngIf="item.role_id == 3">
        <a class="collapsed firstaddClass" href="#submenu1sub1" data-toggle="collapse" data-target="#submenu1sub1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="vuesax_bold_setting-4" data-name="vuesax/bold/setting-4" transform="translate(-428 -190)">
              <g id="setting-4">
                <path id="Vector"
                  d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,0,1,.7.7A.7.7,0,0,1,6.28,1.4Z"
                  transform="translate(443.02 196.18)" fill="#b1b1b1" />
                <path id="Vector-2" data-name="Vector"
                  d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,0,1.4Z"
                  transform="translate(430 196.18)" fill="#b1b1b1" />
                <path id="Vector-3" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                  transform="translate(434.19 192.93)" fill="#b1b1b1" />
                <path id="Vector-4" data-name="Vector"
                  d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,.7.7A.7.7,0,0,1,4.42,1.4Z"
                  transform="translate(444.88 206.41)" fill="#b1b1b1" />
                <path id="Vector-5" data-name="Vector"
                  d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,1,1,0,1.4Z"
                  transform="translate(430 206.41)" fill="#b1b1b1" />
                <path id="Vector-6" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                  transform="translate(437.91 203.17)" fill="#b1b1b1" />
                <path id="Vector-7" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(452 214) rotate(180)"
                  fill="none" opacity="0" />
              </g>
            </g>
          </svg> <span>{{item.role_name}}</span> <i class="fas fa-angle-up"></i> </a>
        <div class="collapse firstmenu" id="submenu1sub1" aria-expanded="false">
          <ul class="flex-column nav" id="accordion">
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/hobbies"
                routerLinkActive="active">
                <span> Hobbies </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/fitness">
                <span> Fitness </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/alcohol-consumption">
                <span> Alcohol Consumption </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/smoker">
                <span> Smoker </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/wake-up-list">
                <span> I usually wake up at </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/interest">
                <span> Interest </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/personality">
                <span> Personality </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/values-list">
                <span> Values </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/life-goals-list">
                <span> Life Goals </span>
              </a>
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/maxion-goals-list">
                <span>Maxion Goals </span>
              </a>

              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLinkActive="active"
                routerLink="/meet-vibes-list">
                <span>Meet Vibes</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a *ngIf="item.role_id == 4" href="javascript:void(0);" routerLinkActive="active" routerLink="/subscriptions">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_ticket-star" data-name="vuesax/bold/ticket-star" transform="translate(-556 -572)">
            <g id="ticket-star">
              <path id="Vector"
                d="M14.641,0H7.9V3.02a.7.7,0,0,1-1.4,0V0H5.341C1.391,0,.091,1.18,0,4.87a.679.679,0,0,0,.2.5.657.657,0,0,0,.5.21,2.56,2.56,0,0,1,0,5.12.672.672,0,0,0-.5.21.679.679,0,0,0-.2.5c.09,3.69,1.39,4.87,5.34,4.87H6.5V13.26a.7.7,0,1,1,1.4,0v3.02h6.74c4.1,0,5.35-1.25,5.35-5.35V5.35C19.991,1.25,18.741,0,14.641,0Zm1.82,8.04-.93.9a.142.142,0,0,0-.04.14l.22,1.27a.625.625,0,0,1-.9.66l-1.15-.6a.171.171,0,0,0-.14,0l-1.15.6a.592.592,0,0,1-.29.07.6.6,0,0,1-.36-.12.625.625,0,0,1-.25-.61l.22-1.27a.179.179,0,0,0-.04-.14l-.93-.9a.616.616,0,0,1-.16-.63.591.591,0,0,1,.5-.42l1.28-.19a.2.2,0,0,0,.12-.08l.57-1.16a.626.626,0,0,1,.56-.34.6.6,0,0,1,.55.34l.57,1.16a.117.117,0,0,0,.11.08l1.28.19a.606.606,0,0,1,.5.42A.574.574,0,0,1,16.461,8.04Z"
                transform="translate(558.009 575.86)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(556 572)" fill="none"
                opacity="0" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span> </a>
      <a *ngIf="item.role_id == 17" href="javascript:void(0);" routerLinkActive="active" routerLink="/connections">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.5 14.99L15.49 20.01" stroke="#000" stroke-width="2.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M3.5 14.99H20.5" stroke="#000" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M3.5 9.00999L8.51 3.98999" stroke="#000" stroke-width="2.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20.5 9.01001H3.5" stroke="#000" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>{{item.role_name}}</span>
      </a>
      <!-- <a *ngIf="item.role_id == 5" href="javascript:void(0);" routerLinkActive="active" 
       ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_convert-card" data-name="vuesax/bold/convert-card" transform="translate(-556 -316)">
            <g id="convert-card">
              <path id="Vector" d="M0,0H24V24H0Z" transform="translate(556 316)" fill="none" opacity="0" />
              <path id="Vector-2" data-name="Vector" d="M7,0A7,7,0,0,1,0,7L1.05,5.25" transform="translate(571 331)"
                fill="none" stroke="#b1b1b1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
              <path id="Vector-3" data-name="Vector" d="M0,7A7,7,0,0,1,7,0L5.95,1.75" transform="translate(558 318)"
                fill="none" stroke="#b1b1b1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
              <path id="Vector-4" data-name="Vector"
                d="M10,2.2v.11a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V2.2C0,.44.44,0,2.22,0H7.78C9.56,0,10,.44,10,2.2Z"
                transform="translate(568 318)" fill="#b1b1b1" />
              <path id="Vector-5" data-name="Vector"
                d="M.5,0A.5.5,0,0,0,0,.5V2.49c0,1.76.44,2.2,2.22,2.2H7.78c1.78,0,2.22-.44,2.22-2.2V.5A.5.5,0,0,0,9.5,0Z"
                transform="translate(568 321.81)" fill="#b1b1b1" />
              <path id="Vector-6" data-name="Vector"
                d="M10,2.2v.11a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V2.2C0,.44.44,0,2.22,0H7.78C9.56,0,10,.44,10,2.2Z"
                transform="translate(558 329.5)" fill="#b1b1b1" />
              <path id="Vector-7" data-name="Vector"
                d="M.5,0A.5.5,0,0,0,0,.5V2.49c0,1.76.44,2.2,2.22,2.2H7.78c1.78,0,2.22-.44,2.22-2.2V.5A.5.5,0,0,0,9.5,0Z"
                transform="translate(558 333.31)" fill="#b1b1b1" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span></a> -->
      <a *ngIf="item.role_id == 5" href="javascript:void(0);" routerLinkActive="active" routerLink="/payments-list">
        <svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.54545 10V8.56312C7.80823 8.63422 8.04047 8.76539 8.24905 8.95658C8.57974 9.25971 8.7278 9.59902 8.72727 9.99934L8.72661 10.5H9.22727H20.1364H20.6364V10C20.6364 9.59861 20.7849 9.25924 21.1154 8.95686C21.4476 8.65284 21.8396 8.50053 22.3187 8.5L22.8182 8.49944V8V4V3.5H22.3182C21.8383 3.5 21.4468 3.34793 21.1157 3.04442C20.7859 2.74213 20.6369 2.40213 20.6364 1.99934L20.6357 1.5H20.1364H9.22727H8.72727V2C8.72727 2.40173 8.57877 2.74166 8.24873 3.04471C8.04064 3.23579 7.80855 3.36682 7.54545 3.43762V2H6.54545V3.49944V4V8V8.5V10H7.54545ZM24 1.99934V2V10C24 10.4017 23.8515 10.7417 23.5215 11.0447C23.1906 11.3485 22.7991 11.5005 22.3187 11.5H22.3182H7.04545C6.56558 11.5 6.17405 11.3479 5.84295 11.0444C5.51327 10.7422 5.36425 10.4023 5.36364 9.99967C5.36364 9.99956 5.36364 9.99945 5.36364 9.99934L5.36364 2C5.36364 1.59861 5.51221 1.25924 5.84264 0.956863C6.17481 0.652895 6.56671 0.500587 7.04575 0.5H22.3182C22.7978 0.5 23.1898 0.652248 23.5218 0.956577C23.8525 1.25971 24.0005 1.59902 24 1.99934ZM1 13.9997V3.5H2.18182V14V14.5H2.68182H20.7273V15.5H2.68182C2.20195 15.5 1.81041 15.3479 1.47932 15.0444C1.14963 14.7422 1.00061 14.4023 1 13.9997ZM14.6818 8.5C13.8905 8.5 13.2404 8.25043 12.7015 7.75642C12.1642 7.26394 11.9091 6.68758 11.9091 6C11.9091 5.31242 12.1642 4.73606 12.7015 4.24358C13.2404 3.74957 13.8905 3.5 14.6818 3.5C15.4731 3.5 16.1232 3.74957 16.6621 4.24358C17.1994 4.73606 17.4545 5.31242 17.4545 6C17.4545 6.68758 17.1994 7.26394 16.6621 7.75642C16.1232 8.25043 15.4731 8.5 14.6818 8.5Z"
            fill="black" stroke="#C9C9C9" />
        </svg>
        <span>{{item.role_name}}</span>
      </a>
      <a *ngIf="item.role_id == 6" href="javascript:void(0);" routerLinkActive="active"
        routerLink="/push-notification"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
          viewBox="0 0 24 24">
          <g id="vuesax_bold_notification-status" data-name="vuesax/bold/notification-status"
            transform="translate(-364 -188)">
            <g id="notification-status">
              <path id="Vector" d="M6,3A3,3,0,1,1,3,0,3,3,0,0,1,6,3Z" transform="translate(380 190)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M17.8,6.42c-.02,0-.04.01-.06.01-.1.02-.2.03-.31.05a4.65,4.65,0,0,1-1.33-.07,3.178,3.178,0,0,1-.33-.09,3.436,3.436,0,0,1-.93-.38,4.05,4.05,0,0,1-.35-.21,4.717,4.717,0,0,1-1.22-1.22,4.05,4.05,0,0,1-.21-.35,3.436,3.436,0,0,1-.38-.93,3.178,3.178,0,0,1-.09-.33,4.65,4.65,0,0,1-.07-1.33c.02-.11.03-.21.05-.31,0-.02.01-.04.01-.06A1,1,0,0,0,11.6,0H5.52c-.14,0-.28.01-.41.02s-.23.02-.35.04-.24.03-.35.05a4.769,4.769,0,0,0-4.3,4.3c-.02.11-.04.23-.05.35s-.03.23-.04.35S0,5.38,0,5.52v7.96c0,.14.01.28.02.41s.02.23.04.35.03.24.05.35a4.769,4.769,0,0,0,4.3,4.3c.11.02.23.04.35.05s.23.03.35.04.27.02.41.02h7.96c.14,0,.28-.01.41-.02s.23-.02.35-.04.24-.03.35-.05a4.769,4.769,0,0,0,4.3-4.3c.02-.11.04-.23.05-.35s.03-.23.04-.35.02-.27.02-.41V7.4A1,1,0,0,0,17.8,6.42ZM4.75,9.5h5a.75.75,0,0,1,0,1.5h-5a.75.75,0,0,1,0-1.5Zm9,5.5h-9a.75.75,0,0,1,0-1.5h9a.75.75,0,0,1,0,1.5Z"
                transform="translate(366 191)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(388 212) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span></a>
      <a *ngIf="item.role_id == 7" href="javascript:void(0);" routerLinkActive="active" routerLink="/partnerships-list">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.1319 22.6625C12.2886 22.6625 12.4492 22.6233 12.6138 22.5449C12.7785 22.4656 12.9115 22.3694 13.013 22.2563L22.3589 11.8397C22.6602 11.5038 22.8924 11.1609 23.0554 10.8108C23.2193 10.459 23.3012 10.0733 23.3012 9.65371C23.3012 9.22882 23.2193 8.81639 23.0554 8.41643C22.8924 8.01559 22.6602 7.65037 22.3589 7.32079L17.8634 2.31021C17.5669 1.97439 17.262 1.72809 16.9487 1.57132C16.6362 1.41454 16.2894 1.33615 15.9082 1.33615C15.5317 1.33615 15.1821 1.41454 14.8592 1.57132C14.5363 1.72809 14.2318 1.97439 13.9457 2.31021L12.9028 3.47266L15.1205 5.9539C15.3579 6.21401 15.5349 6.51019 15.6516 6.84244C15.7683 7.1747 15.827 7.5123 15.8278 7.85525C15.8278 8.55005 15.624 9.12504 15.2165 9.58022C14.8073 10.0345 14.291 10.2617 13.6676 10.2617C13.3599 10.2617 13.0598 10.2096 12.7673 10.1053C12.474 10.0011 12.2106 9.8185 11.9773 9.55751L9.68396 7.0108L4.50752 12.779C4.38604 12.9144 4.29493 13.068 4.23419 13.24C4.17345 13.4128 4.14309 13.5865 4.14309 13.761C4.14309 14.0764 4.23379 14.3365 4.41521 14.5414C4.59663 14.7462 4.8288 14.8487 5.11172 14.8487C5.26836 14.8487 5.429 14.8086 5.59364 14.7284C5.75828 14.65 5.89134 14.5543 5.99284 14.4412L9.79186 10.2069L10.6406 11.1529L6.84759 15.3885C6.72611 15.523 6.635 15.6762 6.57426 15.8481C6.51352 16.0209 6.48315 16.1946 6.48315 16.3692C6.48315 16.6667 6.57786 16.9206 6.76727 17.1308C6.95588 17.3419 7.18405 17.4475 7.45179 17.4475C7.60843 17.4475 7.76907 17.4083 7.93371 17.3299C8.09834 17.2515 8.23141 17.1558 8.33291 17.0426L12.4088 12.5064L13.2564 13.4524L9.18766 17.9953C9.08136 18.1084 8.99425 18.2568 8.92632 18.4403C8.85759 18.6238 8.82322 18.8028 8.82322 18.9774C8.82322 19.2749 8.91793 19.5288 9.10734 19.739C9.29595 19.9501 9.52412 20.0557 9.79186 20.0557C9.9485 20.0557 10.1043 20.0218 10.2594 19.9541C10.4136 19.8864 10.5515 19.7853 10.673 19.6508L14.7489 15.1146L15.5965 16.0606L11.5205 20.6035C11.3991 20.7389 11.3079 20.901 11.2472 21.0899C11.1865 21.2796 11.1561 21.4533 11.1561 21.611C11.1561 21.9263 11.256 22.1806 11.4558 22.3739C11.6548 22.5672 11.8802 22.6638 12.1319 22.6638M12.1247 24C11.5085 24 10.9811 23.7488 10.5423 23.2464C10.1027 22.7431 9.91014 22.1227 9.96449 21.3851C9.28516 21.3941 8.71972 21.1678 8.26818 20.7064C7.81583 20.2459 7.60124 19.6027 7.62442 18.777C6.88355 18.7859 6.30014 18.5498 5.87416 18.0688C5.44739 17.5878 5.25318 16.9545 5.29154 16.1688C4.625 16.1777 4.06716 15.9684 3.61801 15.5408C3.16886 15.115 2.94428 14.5218 2.94428 13.761C2.94428 13.4181 3.00422 13.0752 3.1241 12.7322C3.24318 12.3884 3.41901 12.0864 3.65157 11.8263L9.68396 5.11079L12.7793 8.56074C12.8808 8.67921 13.0063 8.77675 13.1557 8.85336C13.3044 8.92907 13.4722 8.96693 13.6592 8.96693C13.9165 8.96693 14.1435 8.86716 14.3401 8.66763C14.5367 8.4681 14.635 8.20844 14.635 7.88865C14.635 7.67932 14.6011 7.49137 14.5331 7.3248C14.4644 7.15911 14.3773 7.01971 14.2718 6.90658L10.1479 2.31021C9.8506 1.97439 9.54171 1.72809 9.22123 1.57132C8.90154 1.41454 8.55069 1.33615 8.16867 1.33615C7.79225 1.33615 7.45019 1.41454 7.1425 1.57132C6.8356 1.72809 6.53151 1.97439 6.23021 2.31021L2.58104 6.38548C2.3237 6.67053 2.1159 7.01124 1.95766 7.40764C1.79942 7.80403 1.7155 8.21245 1.70591 8.63289C1.69792 8.93486 1.7211 9.22481 1.77544 9.50273C1.83139 9.78154 1.9193 10.0434 2.03918 10.2884L1.13049 11.2999C0.929087 10.9427 0.771644 10.5307 0.658157 10.0639C0.543871 9.59626 0.491523 9.1197 0.501114 8.63423C0.510704 8.02761 0.619795 7.44639 0.828388 6.89055C1.03778 6.33381 1.33668 5.83899 1.72509 5.40608L5.35148 1.36421C5.76946 0.903685 6.21182 0.56074 6.67856 0.335375C7.14529 0.111792 7.64959 0 8.19145 0C8.73491 0 9.23561 0.112237 9.69355 0.336711C10.1523 0.561185 10.5887 0.903685 11.0027 1.36421L12.0456 2.528L13.091 1.36421C13.509 0.903685 13.9473 0.56074 14.4061 0.335375C14.8648 0.111792 15.3655 0 15.9082 0C16.4508 0 16.9551 0.112237 17.4211 0.336711C17.8878 0.561185 18.3278 0.903685 18.7409 1.36421L23.2065 6.34139C23.6205 6.80191 23.9394 7.31901 24.1631 7.89266C24.3877 8.46721 24.5 9.0569 24.5 9.66173C24.5 10.2657 24.3881 10.8233 24.1643 11.3346C23.9398 11.8459 23.6205 12.3323 23.2065 12.7937L13.8606 23.2023C13.6121 23.4802 13.3411 23.6824 13.0478 23.8089C12.7553 23.9354 12.4476 23.9987 12.1247 23.9987"
            fill="black" />
        </svg>

        <span>{{item.role_name}}</span>
      </a>
      <div class="sub-menu-wrap submenu3" *ngIf="item.role_id == 9">
        <a class="collapsed addClass" href="#submenu3sub3" data-toggle="collapse" data-target="#submenu3sub3">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="vuesax_bold_setting-2" data-name="vuesax/bold/setting-2" transform="translate(-300 -190)">
              <g id="setting-2">
                <path id="Vector"
                  d="M18.1,6.659c-1.81,0-2.55-1.28-1.65-2.85a1.9,1.9,0,0,0-.7-2.59L14.02.229a1.669,1.669,0,0,0-2.28.6l-.11.19c-.9,1.57-2.38,1.57-3.29,0L8.23.829a1.641,1.641,0,0,0-2.26-.6l-1.73.99a1.908,1.908,0,0,0-.7,2.6c.91,1.56.17,2.84-1.64,2.84A1.906,1.906,0,0,0,0,8.559v1.76a1.906,1.906,0,0,0,1.9,1.9c1.81,0,2.55,1.28,1.64,2.85a1.9,1.9,0,0,0,.7,2.59l1.73.99a1.669,1.669,0,0,0,2.28-.6l.11-.19c.9-1.57,2.38-1.57,3.29,0l.11.19a1.669,1.669,0,0,0,2.28.6l1.73-.99a1.9,1.9,0,0,0,.7-2.59c-.91-1.57-.17-2.85,1.64-2.85a1.906,1.906,0,0,0,1.9-1.9V8.559A1.921,1.921,0,0,0,18.1,6.659ZM10,12.689a3.25,3.25,0,1,1,3.25-3.25A3.256,3.256,0,0,1,10,12.689Z"
                  transform="translate(302 192.561)" fill="#b1b1b1" />
                <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(324 214) rotate(180)"
                  fill="none" opacity="0" />
              </g>
            </g>
          </svg>
          <span>{{item.role_name}}</span> <i class="fas fa-angle-up"></i> </a>
        <div class="collapse firstmenu" id="submenu3sub3" aria-expanded="false">
          <ul class="flex-column nav" id="accordion">
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/regions-list"
                routerLinkActive="active">
                <span> Regions Groups Tiers </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/roles-list"
                routerLinkActive="active">
                <span> Roles and Access </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link secondsub collapsed menuone" href="javascript:void(0);" routerLink="/change-password"
                routerLinkActive="active">
                <span> Security </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a *ngIf="item.role_id == 10" href="javascript:void(0);" routerLinkActive="active" routerLink="/event-list"><svg
          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_profile-add" data-name="vuesax/bold/profile-add" transform="translate(-364 -252)">
            <g id="profile-add">
              <path id="Vector" d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(371.25 254)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395ZM9.04,5.375H7.79v1.25a.75.75,0,0,1-1.5,0V5.375H5.04a.75.75,0,0,1,0-1.5H6.29V2.625a.75.75,0,1,1,1.5,0v1.25H9.04a.75.75,0,0,1,0,1.5Z"
                transform="translate(368.96 264.755)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(388 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span></a>

      <a *ngIf="item.role_id == 11" href="javascript:void(0);" routerLinkActive="active" routerLink="/experiences-list">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_star-add" data-name="vuesax/bold/star-add" transform="translate(-364 -252)">
            <g id="star-add">
              <path id="Vector" d="M12 2l2.4 7.6h8.4l-6.8 4.8 2.6 7.6-6.6-4.8-6.6 4.8 2.6-7.6-6.8-4.8h8.4L12 2z"
                transform="translate(364 252)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(388 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg>

        <span> {{item.role_name}}</span>
      </a>

      <a *ngIf="item.role_id == 12" href="javascript:void(0);" routerLinkActive="active" routerLink="/grwm-list">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_star-add" data-name="vuesax/bold/star-add" transform="translate(-364 -252)">
            <g id="star-add">
              <path id="Vector" d="M12 2l2.4 7.6h8.4l-6.8 4.8 2.6 7.6-6.6-4.8-6.6 4.8 2.6-7.6-6.8-4.8h8.4L12 2z"
                transform="translate(364 252)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(388 276) rotate(180)"
                fill="none" opacity="0" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span></a>

      <a *ngIf="item.role_id == 13" href="javascript:void(0);" routerLinkActive="active" routerLink="/faq"><svg
          xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_message-question" data-name="vuesax/bold/message-question"
            transform="translate(-620 -252)">
            <g id="message-question">
              <path id="Vector" d="M0,0H24V24H0Z" transform="translate(620 252)" fill="none" opacity="0" />
              <path id="Vector-2" data-name="Vector"
                d="M15,0H5A4.724,4.724,0,0,0,0,5v6a4.724,4.724,0,0,0,5,5v2.13a.994.994,0,0,0,1.55.83L11,16h4a4.724,4.724,0,0,0,5-5V5A4.724,4.724,0,0,0,15,0ZM10,12.17a.75.75,0,1,1,.75-.75A.749.749,0,0,1,10,12.17Zm1.26-4.15c-.39.26-.51.43-.51.71v.21a.75.75,0,0,1-1.5,0V8.73a2.327,2.327,0,0,1,1.17-1.95c.37-.25.49-.42.49-.68a.91.91,0,0,0-1.82,0,.75.75,0,0,1-1.5,0,2.41,2.41,0,0,1,4.82,0A2.294,2.294,0,0,1,11.26,8.02Z"
                transform="translate(622 254.43)" fill="#b1b1b1" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span></a>
      <div class="sub-menu-wrap submenu2" *ngIf="item.role_id == 14">
        <a class="collapsed addClass" href="#submenu2sub2" data-toggle="collapse" data-target="#submenu2sub2"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="vuesax_bold_setting-4" data-name="vuesax/bold/setting-4" transform="translate(-428 -190)">
              <g id="setting-4">
                <path id="Vector"
                  d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,0,1,.7.7A.7.7,0,0,1,6.28,1.4Z"
                  transform="translate(443.02 196.18)" fill="#b1b1b1" />
                <path id="Vector-2" data-name="Vector"
                  d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,0,1.4Z"
                  transform="translate(430 196.18)" fill="#b1b1b1" />
                <path id="Vector-3" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                  transform="translate(434.19 192.93)" fill="#b1b1b1" />
                <path id="Vector-4" data-name="Vector"
                  d="M4.42,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H4.42a.7.7,0,0,1,.7.7A.7.7,0,0,1,4.42,1.4Z"
                  transform="translate(444.88 206.41)" fill="#b1b1b1" />
                <path id="Vector-5" data-name="Vector"
                  d="M6.28,1.4H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H6.28a.7.7,0,1,1,0,1.4Z"
                  transform="translate(430 206.41)" fill="#b1b1b1" />
                <path id="Vector-6" data-name="Vector" d="M7.9,3.95A3.95,3.95,0,1,1,3.95,0,3.95,3.95,0,0,1,7.9,3.95Z"
                  transform="translate(437.91 203.17)" fill="#b1b1b1" />
                <path id="Vector-7" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(452 214) rotate(180)"
                  fill="none" opacity="0" />
              </g>
            </g>
          </svg> <span>{{item.role_name}}</span><i class="fas fa-angle-up"></i> </a>
        <div class="collapse secondmenu" id="submenu2sub2" aria-expanded="false">
          <ul class="flex-column nav">
            <li class="nav-item" routerLinkActive="active" [routerLink]="['/mobile-content-list']">
              <a class="nav-link " href="javascript:void(0);">
                Mobile Content
              </a>
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLink]="['/terms-condition']">
              <a class="nav-link " href="javascript:void(0);">
                Terms and Conditions
              </a>
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLink]="['/privacy-policy']">
              <a class="nav-link " href="javascript:void(0);">
                Privacy Policy
              </a>
            </li>
            <li class="nav-item" routerLinkActive="active" [routerLink]="['/contact-us']">
              <a class="nav-link " href="javascript:void(0);">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a *ngIf="item.role_id == 15" href="javascript:void(0);" routerLinkActive="active" routerLink="/promo-code"><svg
          xmlns="http://www.w3.org/2000/svg" width="20" height="19.141" viewBox="0 0 20 19.141">
          <g id="engagement-ring" transform="translate(0 -11)">
            <path id="Path_30636" data-name="Path 30636"
              d="M243.254,11.368A.586.586,0,0,0,242.71,11h-4.687a.586.586,0,0,0-.544.368l-.634,1.585h7.043Z"
              transform="translate(-227.593 0)" fill="#b1b1b1" />
            <path id="Path_30637" data-name="Path 30637"
              d="M14.453,138.227a7.182,7.182,0,0,0-1.028-3.711h-.652a3.688,3.688,0,0,0-1.867.505A4.881,4.881,0,1,1,5.8,133.558a8.465,8.465,0,0,1,2.558-2.47,7.227,7.227,0,1,0,6.1,7.138Z"
              transform="translate(0 -115.313)" fill="#b1b1b1" />
            <path id="Path_30638" data-name="Path 30638"
              d="M150.629,92.7l1.942-1.7h-6.69l1.942,1.7a7.223,7.223,0,0,0-4.8,10.8h.652a3.688,3.688,0,0,0,1.867-.505,4.881,4.881,0,1,1,5.111,1.463,8.465,8.465,0,0,1-2.558,2.47,7.227,7.227,0,0,0,2.53-14.228Z"
              transform="translate(-136.453 -76.875)" fill="#b1b1b1" />
          </g>
        </svg>
        <span>{{item.role_name}}</span> </a>

      <a *ngIf="item.role_id == 16" href="javascript:void(0);" routerLinkActive="active" routerLink="/manual-match"><svg
          xmlns="http://www.w3.org/2000/svg" width="20" height="19.141" viewBox="0 0 20 19.141">
          <g id="engagement-ring" transform="translate(0 -11)">
            <path id="Path_30636" data-name="Path 30636"
              d="M243.254,11.368A.586.586,0,0,0,242.71,11h-4.687a.586.586,0,0,0-.544.368l-.634,1.585h7.043Z"
              transform="translate(-227.593 0)" fill="#b1b1b1" />
            <path id="Path_30637" data-name="Path 30637"
              d="M14.453,138.227a7.182,7.182,0,0,0-1.028-3.711h-.652a3.688,3.688,0,0,0-1.867.505A4.881,4.881,0,1,1,5.8,133.558a8.465,8.465,0,0,1,2.558-2.47,7.227,7.227,0,1,0,6.1,7.138Z"
              transform="translate(0 -115.313)" fill="#b1b1b1" />
            <path id="Path_30638" data-name="Path 30638"
              d="M150.629,92.7l1.942-1.7h-6.69l1.942,1.7a7.223,7.223,0,0,0-4.8,10.8h.652a3.688,3.688,0,0,0,1.867-.505,4.881,4.881,0,1,1,5.111,1.463,8.465,8.465,0,0,1-2.558,2.47,7.227,7.227,0,0,0,2.53-14.228Z"
              transform="translate(-136.453 -76.875)" fill="#b1b1b1" />
          </g>
        </svg>
        <span>{{item.role_name}}</span> </a>

      <a *ngIf="item.role_id == 18" href="javascript:void(0);" routerLinkActive="active" routerLink="/group-dates">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_profile-2user" data-name="vuesax/bold/profile-2user" transform="translate(-172 -252)">
            <g id="profile-2user">
              <path id="Vector" d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
                transform="translate(176.25 254)" fill="#b1b1b1" />
              <path id="Vector-2" data-name="Vector"
                d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
                transform="translate(173.96 264.755)" fill="#b1b1b1" />
              <path id="Vector-3" data-name="Vector"
                d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
                transform="translate(186.11 256.057)" fill="#b1b1b1" />
              <path id="Vector-4" data-name="Vector"
                d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
                transform="translate(185.99 264.5)" fill="#b1b1b1" />
              <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(196 276) rotate(180)"
                fill="none" opacity="0" />
            </g>`
          </g>
        </svg><span>{{item.role_name}}</span>
      </a>

      <a *ngIf="item.role_id == 25" href="javascript:void(0);" routerLinkActive="active" routerLink="/dynamic-popup">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g transform="translate(-364 -188)">
            <path
              d="M19,3H5A3,3,0,0,0,2,6v9a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,12a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V6A1,1,0,0,1,5,5H19a1,1,0,0,1,1,1Z"
              transform="translate(364 188)" fill="#b1b1b1" />
            <path d="M12,8a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z" transform="translate(364 188)"
              fill="#b1b1b1" />
            <circle cx="12" cy="14.5" r="1" transform="translate(364 188)" fill="#b1b1b1" />
          </g>
        </svg>
        <span>{{item.role_name}}</span>
      </a>

      <a *ngIf="item.role_id == 19" href="javascript:void(0);" routerLinkActive="active" routerLink="/vip-diner">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g id="vuesax_bold_crown" data-name="vuesax/bold/crown" transform="translate(-364 -252)">
            <g id="crown">
              <path id="Vector" d="M0,0H24V24H0Z" transform="translate(388 276) rotate(180)" fill="none" opacity="0" />
              <path id="Vector-2" data-name="Vector"
                d="M16.5,5.5l-2.5,4-2.5-4-2.5,4L6.5,5.5A1.5,1.5,0,0,0,5,7v8a1.5,1.5,0,0,0,1.5,1.5h11A1.5,1.5,0,0,0,19,15V7A1.5,1.5,0,0,0,16.5,5.5Z"
                transform="translate(366 254)" fill="#b1b1b1" />
            </g>
          </g>
        </svg>
        <span>{{item.role_name}}</span>
      </a>

    </li>
  </ul>
</div>
<!-- Sidebar CSS End Here  -->